import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/UserConfigurationData'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class UserConfigurationDataStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "UserConfigurationDataStore",
			variables: false,
		})
	}
}

export async function load_UserConfigurationData(params) {
  await initClient()

	const store = new UserConfigurationDataStore()

	await store.fetch(params)

	return {
		UserConfigurationData: store,
	}
}
